uniform vec2 uResolution;
uniform float uSize;
uniform float uSizeVariance;
uniform sampler2D uParticlesTexture;
uniform sampler2D uColorTexture;
uniform float uUsePerParticleColor;
uniform float uTime;
uniform float uDofFocus;
uniform float uDofAperture;
uniform float uDofMaxBlur;

attribute vec2 aParticlesUv;
attribute float aSize;

varying float vLifetime;
varying float vRandom;
varying float vRandom2;
varying float vDofBlur;
varying vec3 vPerParticleColor;
varying float vUsePerParticleColor;
varying vec3 vWorldPosition;

void main()
{
    vec4 particle = texture(uParticlesTexture, aParticlesUv);

    // Varyings — compute first, used below
    vLifetime = particle.a;
    float dp = dot(aParticlesUv, vec2(12.9898, 78.233));
    dp = fract(dp * 0.1031);
    dp *= dp + 33.33;
    dp *= dp + dp;
    vRandom = fract(dp);
    vRandom2 = aSize;

    // Per-particle color from PLY data
    vUsePerParticleColor = uUsePerParticleColor;
    if(uUsePerParticleColor > 0.5) {
        vec4 colorData = texture(uColorTexture, aParticlesUv);
        vPerParticleColor = colorData.rgb;
    } else {
        vPerParticleColor = vec3(0.0);
    }

    // Final position
    vec4 modelPosition = modelMatrix * vec4(particle.xyz, 1.0);
    vWorldPosition = modelPosition.xyz;
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    // Point size
    float sizeIn = smoothstep(0.0, 0.1, particle.a);
    float sizeOut = 1.0 - smoothstep(0.7, 1.0, particle.a);
    float size = min(sizeIn, sizeOut);

    // Animated size variance per particle — clamp to >=0 so high uSizeVariance doesn't
    // push the size negative (which makes WebGL drop the point and causes flicker).
    float sizeNoise = sin(vRandom * 27.3 + uTime * (0.8 + vRandom * 1.2)) * 0.5 + 0.5;
    float sizeScale = max(0.0, mix(1.0, 0.3 + sizeNoise * 1.4, uSizeVariance));

    gl_PointSize = size * aSize * uSize * sizeScale * uResolution.y;
    gl_PointSize *= (1.0 / - viewPosition.z);

    // Depth of field — particles away from focus plane grow larger and softer
    float viewDepth = -viewPosition.z;
    float dofDist = abs(viewDepth - uDofFocus);
    vDofBlur = clamp(dofDist * uDofAperture, 0.0, uDofMaxBlur);
    gl_PointSize *= (1.0 + vDofBlur * 0.8);
}
